module.exports = __webpack_public_path__ + "static/media/logo.a3842060.png";